import { render, staticRenderFns } from "./RefundTab.vue?vue&type=template&id=70238f90&scoped=true"
import script from "./RefundTab.vue?vue&type=script&lang=js"
export * from "./RefundTab.vue?vue&type=script&lang=js"
import style0 from "./RefundTab.vue?vue&type=style&index=0&id=70238f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70238f90",
  null
  
)

export default component.exports